import type React from 'react';
import { Chip } from '@mui/material';
import type { VideoJobStatus } from '../types';

const COLORS: Record<VideoJobStatus, 'default' | 'info' | 'success' | 'error' | 'warning'> = {
  queued: 'default',
  running: 'info',
  completed: 'success',
  failed: 'error',
  cancelled: 'warning',
};

export const JobStatusChip: React.FC<{ status: VideoJobStatus }> = ({ status }) => (
  <Chip size="small" label={status} color={COLORS[status] ?? 'default'} />
);
